import { z } from "zod"
export const filterAccessManagementFormSchema = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  groups: z.string().optional(),
})
export type FilterAccessManagementFormSchemaProps = z.infer<
  typeof filterAccessManagementFormSchema
>
